/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  contextualFooter constants
 */

export const START_FETCHING_NEARBY_ADDRESSES =
  '@@nzr/contextualFooter/START_FETCHING_NEARBY_ADDRESSES'
export const CLEAR_NEARBY_ADDRESSES = '@@nzr/contextualFooter/CLEAR_NEARBY_ADDRESSES'
export const DONE_FETCHING_NEARBY_ADDRESSES =
  '@@nzr/contextualFooter/DONE_FETCHING_NEARBY_ADDRESSES'
export const ERROR_FETCHING_NEARBY_ADDRESSES =
  '@@nzr/contextualFooter/ERROR_FETCHING_NEARBY_ADDRESSES'
export const RECEIVE_NEARBY_ADDRESSES = '@@nzr/contextualFooter/RECEIVE_NEARBY_ADDRESSES'
export const RECEIVE_DIL_ADDRESSES = '@@nzr/contextualFooter/RECEIVE_DIL_ADDRESSES'
